import { render, staticRenderFns, recyclableRender, components } from "./activityType.vue?vue&type=template&id=5ac524b6&scoped=true&"
var renderjs
import script from "./activityType.vue?vue&type=script&lang=js&"
export * from "./activityType.vue?vue&type=script&lang=js&"
import style0 from "./activityType.vue?vue&type=style&index=0&id=5ac524b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac524b6",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/merchant/activityType.vue"
export default component.exports